<ng-container *ngIf="!detailsLoading && !jobsLoading">
  <div id="building-details">
    <div class="header-building d-flex p-3">
        <img
          [src]="getCover()"
          alt="{{ building.label }}"
          width="90"
          height="90"
          class="align-self-center"
        />
        <div class="gray-text ml-3">
          <h3>{{ building.label }}</h3>
          <div class="d-flex">
            <i class="fas fa-map-marker gray mr-2 mt-1 w-14"></i>
            {{ building.address.houseNumber }}
            {{ building.address.houseNumberExtenstion }}
            {{ building.address.street }}<br/>
            {{ building.address.city }}
          </div>
        </div>
        <div class="building-icons">
          <i *ngIf="doesBuildingHaveUrgentJobs(allJobs)" class="fas fa-exclamation icon-red"></i>
        </div>
    </div>
    <div>
      <mat-tab-group mat-stretch-tabs [selectedIndex]="getDefaultSelectedTab()" (selectedTabChange)='onTabChange($event.index)'>
        <mat-tab>
          <ng-template mat-tab-label>{{ Localization.Requested | translate | uppercase}}</ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>{{ 'Accepted' | translateEnum: 'actionStatusType' | uppercase}}</ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>{{ 'Finished' | translateEnum: 'actionStatusType' | uppercase}}</ng-template>
        </mat-tab>
      </mat-tab-group>
      <div class="filter-jobs" *ngIf="selectedTab == 1">
        <mat-form-field appearance="fill" style="max-width: 125px;">
          <mat-select (selectionChange)="selectionChange($event.value)" [(value)]="selected">
            <mat-option value="all">{{ Localization.AllUpcoming | translate}}</mat-option>
            <mat-option *ngFor="let date of filterDates" [value]="date">{{ date | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-nav-list>
        <a style="height: auto; display: block;" id="job" mat-list-item (click)="onJobClicked(job.id)" *ngFor="let job of filteredJobs" mdbWavesEffect (press)="onPress(job.id)" (pressUp)="onPressUp()" [ngClass]="{'selected': isJobSelected(job.id), 'prevent-pointer-events': isBeingPressed && false}">
          <div class="job-description">
            <div class="title mb-1">{{ job.type | translateEnum: 'actionType'}}</div>
            <div class="description gray-text">
              <div *ngIf="job.instructions" class="d-flex mr-4"><i class="fas fa-info-circle gray mr-2 w-14"></i><span>{{job.instructions}}</span></div>
              <div *ngIf="getJobLocation(job)" class="d-flex"><i class="fas fa-map-marker gray mr-2 w-14"></i><span>{{getJobLocation(job)}}</span></div>
            </div>
            <div class="priority">
              <i *ngIf="doesBuildingHaveUrgentJobs(allJobs)" class="fas fa-exclamation icon-red"></i>
            </div>
            <div class="more icon">
              <span>{{ Localization.SeeMore | translate }}</span><i class="fas fa-chevron-right"></i>
            </div>
          </div>
          <mat-divider></mat-divider>
        </a>
      </mat-nav-list>
      <div class="center job-actions" *ngIf="multiSelectOn && this.selectedTab === 0">
        <chapps-success-button [small]="true" [label]="Localization.AcceptSelected | translate"
          (clicked)="accept()">
        </chapps-success-button>
        <chapps-danger-button [small]="true" [label]="Localization.RejectSelected | translate"
          (clicked)="decline()">
        </chapps-danger-button>
      </div>
      <div class="center job-actions" *ngIf="multiSelectOn && this.selectedTab === 1">
        <chapps-success-button [small]="true" [label]="hasMultipleJobsSelected ? Localization.FinishJobs : Localization.FinishJob | translate"
          (clicked)="execute()">
        </chapps-success-button>
        <chapps-danger-button [small]="true" [label]="Localization.Decline | translate"
          (clicked)="declinePreviouslyAcceptedJobs()">
        </chapps-danger-button>
      </div>
      <div *ngIf="filteredJobs.length == 0" class="emptyDataMessage text-center gray-text mt-3"> {{ Localization.EmptyDataMessage | translate }} </div>
    </div>
  </div>
</ng-container>
<app-card-spinner [show]="detailsLoading || jobsLoading"></app-card-spinner>
<app-execute-modal [ids]="this.jobsSelected"></app-execute-modal>
<app-decline-modal [ids]="this.jobsSelected"></app-decline-modal>
